<template>
  <div>
    <div style="padding:0 1rem;margin-top:2rem;">
      <mt-button @click.native="dealerList" size="large" type="primary">经销商管理</mt-button>
      <mt-button @click.native="scanDealer" size="large" type="primary">扫码发货</mt-button>
      <!-- <mt-button @click.native="prodTrack" size="large" type="primary">产品稽查</mt-button> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Button } from "mint-ui";

Vue.component(Button.name, Button);

export default {
  methods: {
    dealerList() {
      this.$router.push("/ent/dealer");
    },
    scanDealer() {
      this.$router.push("/ent/sales/choose_dealer");
    },
    prodTrack() {
      this.$router.push("/ent/prod/track");
    }
  }
};
</script>
<style scoped>
.mint-button--large{margin-top:1rem;}
</style>